import api from "../lib/apiClient";
export const getLiveTraders = () => api.get("/settings/live-traders").then((r) => r.data);
export const adminSetLiveTraders = (count) => api.patch("/admin/settings/live-traders", { count }).then((r) => r.data);
